import { Transition, Transitions } from 'types/Transitions';
import { createActionCreator, createReducer } from 'deox';
import { AppState } from 'types/AppState';
import { deleteScene } from 'modules/effects';

const defaultTransitionsState: Transitions = {
  current: null
};

export const selectCurrentTransition = createActionCreator(
  'TRANSITIONS/SELECT_CURRENT',
  resolve => (payload: string) => resolve(payload)
);

export const setTransitionList = createActionCreator(
  'TRANSITIONS/SET_LIST',
  resolve => (payload: Transition[]) => resolve(payload)
);

export const loadTransitions = createActionCreator('TRANSITIONS/LOAD');

export const transitions = createReducer(defaultTransitionsState, handle => [
  handle(selectCurrentTransition, (state, { payload }) => ({ ...state, current: payload })),
  handle(setTransitionList, (state, { payload }) => ({ ...state, list: payload })),
  handle(deleteScene, state => ({ ...state, current: null }))
]);

export const getCurrentTransitionId = (state: AppState): string | null => state.transitions.current;
export const getAvailableTransitions = (state: AppState): Transition[] => state.transitions.list;
